import styled from 'styled-components';

export const SelectButtonStyle = styled.div`
  width: 100%;
  min-width: 340px;
  margin: 10px auto;
  position: relative;
`;
